import {dateTime, duration} from "services/date";
import {MembershipPlan} from "types/MembershipPlan";

/**
 * Transform the given membership plan by deserializing object properties
 *
 * @internal
 * @param membershipPlan
 */
export default function deserializeMembershipPlan(membershipPlan: any): MembershipPlan {
    membershipPlan.duration = duration(membershipPlan.duration.iso)
    membershipPlan.created_at = dateTime(membershipPlan.created_at)
    membershipPlan.updated_at = dateTime(membershipPlan.updated_at)

    return membershipPlan;
}